import React from "react";
import PropTypes from "prop-types";
import { TextField, FormGroup, MenuItem, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import { COUNTRIES } from "../../../../const";

const KidInformations = props => {
  const { values, handleChange, handleBlur, errors, touched, style } = props;
  const { t } = useTranslation();

  return (
    <div>
      <h5>{t("add_kid.kid_info.title")}</h5>
      <Grid container spacing={24}>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.nom")}
              name="nom"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.nom && errors.nom}
                </span>
              }
              value={values.nom}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.prenom")}
              name="prenom"
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.prenom && errors.prenom}
                </span>
              }
              value={values.prenom}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.date_naissance")}
              name="dateNaissance"
              variant="outlined"
              type="date"
              format={"DD/MM/YYYY"}
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.dateNaissance && errors.dateNaissance}
                </span>
              }
              value={values.dateNaissance}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.date_admission")}
              name="dateAdmission"
              variant="outlined"
              type="date"
              format={"DD/MM/YYYY"}
              InputLabelProps={{
                shrink: true
              }}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.dateAdmission && errors.dateAdmission}
                </span>
              }
              value={values.dateAdmission}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={8}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.rue")}
              name="adresseDto['rue']"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["rue"] &&
                    errors.adresseDto &&
                    errors.adresseDto["rue"]}
                </span>
              }
              value={values.adresseDto["rue"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.ville")}
              name="adresseDto['ville']"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["ville"] &&
                    errors.adresseDto &&
                    errors.adresseDto["ville"]}
                </span>
              }
              value={values.adresseDto["ville"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.code_postal")}
              name="adresseDto['codePostale']"
              variant="outlined"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["codePostale"] &&
                    errors.adresseDto &&
                    errors.adresseDto["codePostale"]}
                </span>
              }
              value={values.adresseDto["codePostale"]}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label={t("add_kid.kid_info.pays")}
              name="adresseDto['pays']"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.adresseDto &&
                    touched.adresseDto["pays"] &&
                    errors.adresseDto &&
                    errors.adresseDto["pays"]}
                </span>
              }
              value={values.adresseDto["pays"]}
            >
              {COUNTRIES.map(country => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.poids")}
              name="poid"
              variant="outlined"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.poid && errors.poid}
                </span>
              }
              value={values.poid}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              label={t("add_kid.kid_info.taille")}
              name="taille"
              variant="outlined"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.taille && errors.taille}
                </span>
              }
              value={values.taille}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            <TextField
              select
              label={t("add_kid.kid_info.sexe")}
              name="sexe"
              variant="outlined"
              type="text"
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={
                <span className={style.formError}>
                  {touched.sexe && errors.sexe}
                </span>
              }
              value={values.sexe}
            >
              <MenuItem key="M" value="Masculin">
                {t("add_kid.kid_info.masculin")}
              </MenuItem>
              <MenuItem key="F" value="Feminin">
                {t("add_kid.kid_info.feminin")}
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
      </Grid>
    </div>
  );
};

KidInformations.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleDisplayCamera: PropTypes.func,
  displayCamera: PropTypes.bool,
  touched: PropTypes.object,
  style: PropTypes.object
};

export default KidInformations;
